import React from 'react';
import classNames from 'classnames';

import css from './ListingPage.module.css';

/**
 * Native <details>-based accordion for product-page sections (Description,
 * Specifications, Files, Certifications, etc.). Using <details> rather than
 * a JS-driven collapse gives free keyboard nav (Enter/Space toggle), screen-
 * reader semantics (aria-expanded handled by the browser), and persistent
 * open state across HMR reloads in dev.
 *
 * Visual: section title row with rotating chevron on the right; clicking
 * anywhere on the row toggles. Body padding mirrors the section padding
 * convention used elsewhere on ListingPage (24px mobile, 0 desktop).
 */
const CollapsibleSection = props => {
  const { title, defaultOpen = false, children, className } = props;

  return (
    <details
      className={classNames(css.collapsibleSection, className)}
      open={defaultOpen || undefined}
    >
      <summary className={css.collapsibleSummary}>
        <span className={css.collapsibleTitle}>{title}</span>
        {/* Sleek text-arrow chevron — points → when closed, rotates 90°
            clockwise to point ↓ when open. Mirrors the typography of
            the topbar back-arrow (Topbar.module.css `.signupBackArrow`)
            for visual consistency across the app. */}
        <span className={css.collapsibleChevron} aria-hidden="true">→</span>
      </summary>
      <div className={css.collapsibleBody}>{children}</div>
    </details>
  );
};

export default CollapsibleSection;
